var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("VueEditor", {
    ref: "editor",
    attrs: {
      id: "field-post_content",
      name: _vm.fieldName,
      placeholder: "Start writing...",
      required: "",
      editorOptions: _vm.editorOptions,
    },
    on: { focus: _vm.handleFocus, blur: _vm.handleBlur },
    model: {
      value: _vm.value,
      callback: function ($$v) {
        _vm.value = $$v
      },
      expression: "value",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }